module.exports = __webpack_public_path__ + "img/jshopQrcode.a5f57fa3.png";